import type { PrayerLocation } from "@/types/prayer";

export const prayerLocations: PrayerLocation[] = [
  {
    id: "toronto",
    label: "Toronto",
    city: "Toronto",
    country: "Canada",
    continent: "North America",
    lat: 43.6532,
    lon: -79.3832,
    timeZone: "America/Toronto",
  },
  {
    id: "new-york",
    label: "New York",
    city: "New York",
    country: "United States",
    continent: "North America",
    lat: 40.7128,
    lon: -74.006,
    timeZone: "America/New_York",
  },
  {
    id: "san-francisco",
    label: "San Francisco",
    city: "San Francisco",
    country: "United States",
    continent: "North America",
    lat: 37.7749,
    lon: -122.4194,
    timeZone: "America/Los_Angeles",
  },
  {
    id: "portland",
    label: "Portland",
    city: "Portland",
    country: "United States",
    continent: "North America",
    lat: 45.5152,
    lon: -122.6784,
    timeZone: "America/Los_Angeles",
  },
  {
    id: "montreal",
    label: "Montreal",
    city: "Montreal",
    country: "Canada",
    continent: "North America",
    lat: 45.5017,
    lon: -73.5673,
    timeZone: "America/Toronto",
  },
  {
    id: "dublin",
    label: "Dublin",
    city: "Dublin",
    country: "Ireland",
    continent: "Europe",
    lat: 53.3498,
    lon: -6.2603,
    timeZone: "Europe/Dublin",
  },
  {
    id: "london",
    label: "London",
    city: "London",
    country: "United Kingdom",
    continent: "Europe",
    lat: 51.5074,
    lon: -0.1278,
    timeZone: "Europe/London",
  },
  {
    id: "frankfurt",
    label: "Frankfurt",
    city: "Frankfurt",
    country: "Germany",
    continent: "Europe",
    lat: 50.1109,
    lon: 8.6821,
    timeZone: "Europe/Berlin",
  },
  {
    id: "cairo",
    label: "Cairo",
    city: "Cairo",
    country: "Egypt",
    continent: "Africa",
    lat: 30.0444,
    lon: 31.2357,
    timeZone: "Africa/Cairo",
  },
  {
    id: "makkah",
    label: "Makkah",
    city: "Makkah",
    country: "Saudi Arabia",
    continent: "Middle East",
    lat: 21.3891,
    lon: 39.8579,
    timeZone: "Asia/Riyadh",
  },
  {
    id: "karachi",
    label: "Karachi",
    city: "Karachi",
    country: "Pakistan",
    continent: "Asia",
    lat: 24.8607,
    lon: 67.0011,
    timeZone: "Asia/Karachi",
  },
  {
    id: "mumbai",
    label: "Mumbai",
    city: "Mumbai",
    country: "India",
    continent: "Asia",
    lat: 19.076,
    lon: 72.8777,
    timeZone: "Asia/Kolkata",
  },
  {
    id: "tokyo",
    label: "Tokyo",
    city: "Tokyo",
    country: "Japan",
    continent: "Asia",
    lat: 35.6762,
    lon: 139.6503,
    timeZone: "Asia/Tokyo",
  },
  {
    id: "singapore",
    label: "Singapore",
    city: "Singapore",
    country: "Singapore",
    continent: "Asia",
    lat: 1.3521,
    lon: 103.8198,
    timeZone: "Asia/Singapore",
  },
  {
    id: "kuala-lumpur",
    label: "Kuala Lumpur",
    city: "Kuala Lumpur",
    country: "Malaysia",
    continent: "Asia",
    lat: 3.139,
    lon: 101.6869,
    timeZone: "Asia/Kuala_Lumpur",
  },
  {
    id: "sydney",
    label: "Sydney",
    city: "Sydney",
    country: "Australia",
    continent: "Oceania",
    lat: -33.8688,
    lon: 151.2093,
    timeZone: "Australia/Sydney",
  },
  {
    id: "sao-paulo",
    label: "São Paulo",
    city: "São Paulo",
    country: "Brazil",
    continent: "South America",
    lat: -23.5505,
    lon: -46.6333,
    timeZone: "America/Sao_Paulo",
  },
  {
    id: "cape-town",
    label: "Cape Town",
    city: "Cape Town",
    country: "South Africa",
    continent: "Africa",
    lat: -33.9249,
    lon: 18.4241,
    timeZone: "Africa/Johannesburg",
  },
];

export const defaultLocationId = prayerLocations[0]?.id ?? "toronto";

export const getLocationById = (locationId: string) => prayerLocations.find((location) => location.id === locationId);

export const groupLocationsByContinent = () => {
  const groups = new Map<string, PrayerLocation[]>();

  for (const location of prayerLocations) {
    const current = groups.get(location.continent) ?? [];
    current.push(location);
    groups.set(location.continent, current);
  }

  return Array.from(groups.entries()).map(([continent, locations]) => ({
    continent,
    locations,
  }));
};

export const groupLocationsByTimeZone = () => {
  const groups = new Map<string, PrayerLocation[]>();

  for (const location of prayerLocations) {
    const current = groups.get(location.timeZone) ?? [];
    current.push(location);
    groups.set(location.timeZone, current);
  }

  return Array.from(groups.entries()).map(([timeZone, locations]) => ({
    locations,
    timeZone,
  }));
};

export const getAdjacentLocationId = (locationId: string | null, direction: -1 | 1) => {
  const fallbackId = prayerLocations[0]?.id ?? defaultLocationId;

  if (prayerLocations.length === 0) {
    return fallbackId;
  }

  const currentIndex = locationId ? prayerLocations.findIndex((location) => location.id === locationId) : 0;
  const safeIndex = currentIndex >= 0 ? currentIndex : 0;
  const nextIndex = (safeIndex + direction + prayerLocations.length) % prayerLocations.length;

  return prayerLocations[nextIndex]?.id ?? fallbackId;
};
